import React from 'react'
import { PiTimer, PiMagicWand, PiLightning } from 'react-icons/pi'

export { SlackIcon } from './SlackIcon'
export { TeamsIcon } from './TeamsIcon'
export { GoogleIcon } from './GoogleIcon'

// Phosphor icon wrappers with matching style
export const LightningIcon = () => <PiLightning size={16} color="#8897AE" />
export const TimerIcon = () => <PiTimer size={16} color="#8897AE" />
export const GearsIcon = () => <PiMagicWand size={16} color="#8897AE" />
